<template>
  <vk-modal-body>
    <services-modal-header>
      The service {{ service.service_display_name || service.name }} is
      not available for {{ selectedLocation.zipcode }}
    </services-modal-header>
    <services-modal-body>
      <div class="d-flex fd-column flex-center">
        <div class="m-x-2 m-x-6:t">
          We're sorry, we don't have pros in your area yet,
          but are working hard to expand our network so please check back soon.
        </div>
        <button
            class="d-block btn m-t-2"
            selenium="unavailable-modal-button-ok"
            @click="$emit('close')">
          Ok
        </button>
      </div>
    </services-modal-body>
  </vk-modal-body>
</template>
<script>
import ServicesModalHeader from './components/ServicesModalHeader';
import ServicesModalBody from './components/ServicesModalBody';

export default {
  name: 'unavailable-modal',
  components: {
    ServicesModalHeader,
    ServicesModalBody,
  },
  props: {
    selectedLocation: {
      type: Object,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
  },
};
</script>
